/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Conditionings} from '../../core/_models'

type Props = {
  Conditionings: Conditionings
}

const ConditioningsTags: FC<Props> = ({Conditionings}) => (
  <div className='d-flex text-center justify-content-center'>
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 fw-semibold fs-8 mb-1'>
        {Conditionings.tags?.map((tag) => (
          <span
            key={tag.id}
            className='badge badge-light-primary me-1'
            style={{
              whiteSpace: 'pre-line',
              fontSize: '9px',
            }}
          >
            {tag.name?.['pt-BR']}
          </span>
        ))}
      </a>
    </div>
  </div>
)

export {ConditioningsTags}
